.page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* The month and its Save as PDF share a line, wrapping on a phone. */
.month {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

/* On a desktop the day card sits under the chart at a readable width rather
 * than stretching across the whole column. */
@media (min-width: 720px) {
  .page > :last-child {
    max-width: 520px;
  }
}
